import React from 'react'
import { Box, Paragraph } from 'grommet'
import styled from 'styled-components'
import { StaticImage } from 'gatsby-plugin-image'

const LinkPost = styled.a`
  cursor: pointer;
  text-decoration: none;
  color: ${props => props.theme.global.colors.text};
`

const Container = styled(Box)`
  /* cursor: pointer; */
  overflow: hidden;
  max-width: 32rem;
  /* padding: 1rem 0.5rem; */
  border: 2px solid ${props => props.theme.global.colors.border};
  border-radius: 1rem;
  /* &:hover {
    box-shadow: 0px 0px 0px 1px ${props => props.theme.global.colors.border};
  } */
  & div.gatsby-image-wrapper > picture > img {
    opacity: 1 !important;
  }
`

const Headline = styled(Paragraph)`
  font-size: 1.8rem;
  margin-bottom: 1rem;
  margin-top: 1rem;
  line-height: 1.4;
`

const CTA = styled(Paragraph)`
  font-size: 2rem;
  margin-bottom: 0rem;
  font-weight: 700;
  &:hover {
    text-decoration: underline;
    color: ${props => props.theme.global.colors.secondary};
  }
`

const FlipsimuPost = ({ url, title, image, alt, altPost, cta, tool }) => {
  return (
    <Container align="stretch">
      {tool === 'coin' && (
        <StaticImage
          src="../../images/common/FlipSimu-coin-flipper.png"
          width={300}
          height={135}
          placeholder="none"
          loading="eager"
          alt={alt}
        />
      )}
      {tool === 'dice' && (
        <StaticImage
          src="../../images/common/FlipSimu-dice-roller.png"
          width={300}
          height={135}
          placeholder="none"
          loading="eager"
          alt={alt}
        />
      )}
      <Box pad=" 0 .5rem 1rem">
        <Headline textAlign="center">{title}</Headline>
        <LinkPost href={url} target="_blank" alt={altPost}>
          <CTA textAlign="center">{cta}</CTA>
        </LinkPost>
      </Box>
    </Container>
  )
}

export default FlipsimuPost
